import moment from 'moment';

export const overlapType = (currentEvent, otherEvents) => {
    const currentEventStartDate = moment(currentEvent.schedule_start);
    const otherSubscribedEvents = otherEvents.filter(e => e.id !== currentEvent.id);

    const startsAfter = otherSubscribedEvents.find(otherEvent => {
        const otherEventStartDate = moment(otherEvent.schedule_start);
        const otherEventEndDate = moment(otherEvent.schedule_end);
        return currentEventStartDate.isAfter(otherEventStartDate) && currentEventStartDate.isBefore(otherEventEndDate);
    });

    if (startsAfter) return 'after';

    // Same schedule_start
    const sameStartTimeEvents = otherSubscribedEvents.filter(otherEvent => otherEvent.schedule_start === currentEvent.schedule_start);

    if (sameStartTimeEvents.length > 0) {
        const sameStartTimeEventsSubscriptions = sameStartTimeEvents.map(sameTimeEvent => sameTimeEvent.subscriptions).flat();

        const eventIsOverlapped = !sameStartTimeEventsSubscriptions.every(
            subscription => currentEvent.subscriptions.some(sub => moment(sub.created_at).isAfter(moment(subscription.created_at))));

        if (eventIsOverlapped) return 'same';
    }
};

export const overlapBehavior = (currentEvent, otherEvents) => {
    const currentEventStartDate = moment(currentEvent.schedule_start);
    const currentEventEndDate = moment(currentEvent.schedule_end);
    const otherSubscribedEvents = otherEvents.filter(e => e.id !== currentEvent.id);

    const startsBeforeAndEndsBefore = otherSubscribedEvents.find(
        otherEvent => currentEventStartDate.isBefore(moment(otherEvent.schedule_start)) && currentEventEndDate.isBetween(moment(otherEvent.schedule_start), moment(otherEvent.schedule_end)));
    if (startsBeforeAndEndsBefore) return 'before_start_before_end';

    const startsBeforeAndEndsAfter = otherSubscribedEvents.find(
        otherEvent => currentEventStartDate.isBefore(moment(otherEvent.schedule_start)) && currentEventEndDate.isSameOrAfter(moment(otherEvent.schedule_end)));
    if (startsBeforeAndEndsAfter) return 'before_start_after_end';

    const startsAfterAndEndsAfter = otherSubscribedEvents.find(
        otherEvent => currentEventStartDate.isBetween(moment(otherEvent.schedule_start), moment(otherEvent.schedule_end)) && currentEventEndDate.isSameOrAfter(moment(otherEvent.schedule_end)));
    if (startsAfterAndEndsAfter) return 'after_start_after_end';

    const startsAfterAndEndsBefore = otherSubscribedEvents.find(
        otherEvent => currentEventStartDate.isBetween(moment(otherEvent.schedule_start), moment(otherEvent.schedule_end)) && currentEventEndDate.isSameOrBefore(moment(otherEvent.schedule_end)));
    if (startsAfterAndEndsBefore) return 'after_start_before_end';

    const sameStartTimeEvents = otherSubscribedEvents.filter(otherEvent => otherEvent.schedule_start === currentEvent.schedule_start);

    if (sameStartTimeEvents.length > 0) return 'same_start';
};
